import { defineStore } from 'pinia'
import { ref } from 'vue'
import { canUseRestaurantAdminMode } from '@/utils/appModeEligibility'

export const useAppModeStore = defineStore('appMode', () => {
  const mode = ref('member') // 'member' | 'restaurantAdmin'
  const hydrated = ref(false)
  const isDrawerOpen = ref(false)

  function openDrawer() {
    isDrawerOpen.value = true
  }
  function closeDrawer() {
    isDrawerOpen.value = false
  }

  function hydrate(userId, user) {
    if (!userId) {
      mode.value = 'member'
      hydrated.value = true
      
      return
    }

    const saved = localStorage.getItem(`appMode:${userId}`)
    const isEligible = canUseRestaurantAdminMode(user)

    if (saved === 'restaurantAdmin' && isEligible) {
      mode.value = 'restaurantAdmin'
    } else {
      mode.value = 'member'
    }

    hydrated.value = true
  }

  function setMode(newMode, userId) {
    mode.value = newMode
    if (userId) {
      localStorage.setItem(`appMode:${userId}`, newMode)
    }
  }

  function resetOnLogout() {
    mode.value = 'member'
    hydrated.value = false
  }

  return { mode, hydrated, isDrawerOpen, openDrawer, closeDrawer, hydrate, setMode, resetOnLogout }
})
